import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a276542c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-center" }

import BreadCrumb from '@/components/breadCrumb/index.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BreadCrumb, { "module-name": "账号管理" }),
    _createVNode(_component_router_view)
  ]))
}
}

})